/**
 * Storage関連ユーティリティ関数
 */

import { getImageByPath, global_logo_svg } from '@/assets/image-size-mapping';

// ========================================
// ホステスプロフィール画像
// ========================================

const HOSTESS_PROFILES_BUCKET = "hostess-profiles";

/**
 * ホステスプロフィール画像の公開URLを生成
 */
export function getHostessProfileImageUrl(path: string | null | undefined): string | null {
  if (!path) return null;

  const supabaseUrl = import.meta.env.PUBLIC_SUPABASE_URL;
  if (!supabaseUrl) {
    console.warn("[storage-utils] PUBLIC_SUPABASE_URL is not set");
    return null;
  }

  return `${supabaseUrl}/storage/v1/object/public/${HOSTESS_PROFILES_BUCKET}/${path}`;
}

/**
 * ホステスプロフィール画像のプレースホルダーSVG
 */
export function getHostessPlaceholderImage(): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="#9ca3af">
    <circle cx="50" cy="35" r="20"/>
    <path d="M50 60c-22 0-40 12-40 27v13h80v-13c0-15-18-27-40-27z"/>
  </svg>`;

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

/**
 * ホステスプロフィール画像URLまたはプレースホルダーを取得
 */
export function getHostessProfileImageUrlOrPlaceholder(path: string | null | undefined): string {
  return getHostessProfileImageUrl(path) || getHostessPlaceholderImage();
}

// ========================================
// 店舗ロゴ
// ========================================

const DEFAULT_STORE_LOGO_PATH = "/img/global/logo.svg";

/**
 * 店舗ロゴのURLを取得
 */
export function getStoreLogoUrl(logoPath: string | null | undefined): string {
  return logoPath || DEFAULT_STORE_LOGO_PATH;
}

/**
 * 店舗ロゴのAppPicture用画像データを取得
 * image-size-mappingのオブジェクトを返す（width, height, hash付き）
 */
export function getStoreLogoMapping(logoPath: string | null | undefined) {
  const path = logoPath || DEFAULT_STORE_LOGO_PATH;
  return getImageByPath(path) || global_logo_svg;
}
